import { Injectable } from '@angular/core';
import { EnvironmentModel } from '@common/generic/models/EnvironmentModel';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TestCasesCollection } from '../models/TestCasesCollection';

@Injectable({
  providedIn: 'root'
})
export class TestCasesService {
  baseUrl: string;

  constructor(
    private environment: EnvironmentModel,
    private http: HttpClient
  ) {
    this.baseUrl = `${this.environment.apiEndpoint}/spa/testcases`;
  }

  getTestCasesCollections(): Observable<TestCasesCollection[]> {
    return this.http.get<TestCasesCollection[]>(this.baseUrl);
  }
}
